import React, { useMemo, useSyncExternalStore } from "react";
import PropTypes from "prop-types";

import { assertOneOf } from "../internal/contracts";
import { ThemeAContext } from "../internal/ThemeAContext";
import { getDensityPreference, subscribeDensityPreference } from "./density";
import "../tailwind.css";

const DENSITIES = ["comfortable", "compact"];
const serverDensity = () => "comfortable";

export function ThemeAProvider({ children, density = null }) {
  if (density !== null) assertOneOf("ThemeAProvider", "density", density, DENSITIES);
  // Sans densité explicite, chaque provider (celui du shell comme les ~80
  // instanciés par les vues) suit la préférence globale : le réglage du
  // drawer Confidentialité agit donc partout, sans câblage par vue.
  const preferredDensity = useSyncExternalStore(subscribeDensityPreference, getDensityPreference, serverDensity);
  const resolvedDensity = density ?? preferredDensity;
  const value = useMemo(() => ({ density: resolvedDensity }), [resolvedDensity]);

  return (
    <ThemeAContext.Provider value={value}>
      <div
        className="akv:font-ak-body akv:text-ak-text"
        data-akongo-ui="v2"
        data-density={resolvedDensity}
      >
        {children}
      </div>
    </ThemeAContext.Provider>
  );
}

ThemeAProvider.propTypes = {
  children: PropTypes.node.isRequired,
  density: PropTypes.oneOf(DENSITIES),
};
